<template>
    <div class="property-listing card rounded-3" :class="border ? 'border' : 'border-0'">
        <div class="listing-img-wrapper p-3">
            <div class="list-img-slide position-relative">
                <router-link
                    :to="`/service-provider/show-details/${props.item.id}`"
                    target="_blank"
                    rel="noopener noreferrer"
                    >
                    <div class="rounded-3 overflow-hidden mb-0 slick-slider">
                        <img :src="props.item.profile_image" class="img-fluid-2" alt="" />
                    </div>
                </router-link>
            </div>
        </div>
        <div class="listing-caption-wrapper px-3">
            <div class="listing-detail-wrapper">
                <div class="listing-short-detail-wrap">
                    <div class="listing-short-detail">
                        <div class="d-flex align-items-center">
                            <!-- <span v-if="item.tag2 === 'For Rent'" class="label bg-light-success text-success prt-type me-2">For Rent</span>
                            <span v-if="item.tag2 === 'For Sell'"  class="label bg-light-danger text-danger prt-type me-2">For Sell</span> -->
                            <span class="label bg-light-purple text-purple property-cats">{{props.item.name}}</span>&nbsp;
                            <span class="label bg-light-purple text-purple property-cats">{{props.item.category.name}}</span>
                        </div>
                        <div class="prt-location text-muted-2 d-flex align-items-center"><span class="svg-icon svg-icon-2hx"></span>{{props.item.state.name}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {defineProps} from 'vue';
const props = defineProps({
  item: Object,
  border: Boolean
});

</script>

<style scoped>
.img-fluid-2 {
  max-width: 100%;
  height: 222px;
}
</style>
